export default "__VITE_ASSET__FESNaI$$__"